// src/vocabulary/A2/unit3/content.js

const content = {
  level: "A2",
  unit: 3,
  title: "Drinks & Ordering",
  description:
    "Common drinks and simple phrases used when ordering food or drinks. Learn how to ask and respond politely.",

  explanation: [
    "This unit helps you talk about drinks and ordering in restaurants or cafés.",
    "You will learn names of common drinks and useful words for ordering.",
    "In English, people often use polite phrases when ordering.",
    "For example: Can I have a coffee, please?",
    "Words like 'water', 'coffee', and 'juice' are very common in daily life.",
    "You can also use 'would like' to sound more polite.",
    "For example: I would like some tea.",
    "Try to imagine yourself in a café and practice ordering a drink."
  ],

  items: [
    {
      word: "water",
      phonetic: "/ˈwɔːtər/",
      meaning: "ماء",
      example: "Can I have some water, please?"
    },
    {
      word: "coffee",
      phonetic: "/ˈkɒfi/",
      meaning: "قهوة",
      example: "I drink coffee in the morning."
    },
    {
      word: "tea",
      phonetic: "/tiː/",
      meaning: "شاي",
      example: "She would like a cup of tea."
    },
    {
      word: "juice",
      phonetic: "/dʒuːs/",
      meaning: "عصير",
      example: "Orange juice is very popular."
    },
    {
      word: "menu",
      phonetic: "/ˈmenjuː/",
      meaning: "قائمة الطعام",
      example: "Can I see the menu, please?"
    },
    {
      word: "order",
      phonetic: "/ˈɔːrdər/",
      meaning: "يطلب",
      example: "I want to order a drink."
    },
    {
      word: "bill",
      phonetic: "/bɪl/",
      meaning: "الحساب",
      example: "Can we have the bill, please?"
    }
  ]
};

export default content;


